import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useNodeRenderers } from '@myst-theme/providers';
function DefaultComponent({ node }) {
    if (!node.children)
        return _jsx("span", { children: node.value });
    return (_jsx("div", { children: _jsx(MyST, { ast: node.children }) }));
}
export function MyST({ ast }) {
    var _a, _b;
    const renderers = useNodeRenderers();
    if (!ast || ast.length === 0)
        return null;
    if (!Array.isArray(ast)) {
        const Component = (_b = (_a = renderers[ast.type]) !== null && _a !== void 0 ? _a : renderers['DefaultComponent']) !== null && _b !== void 0 ? _b : DefaultComponent;
        return _jsx(Component, { node: ast }, ast.key);
    }
    return (_jsx(_Fragment, { children: ast === null || ast === void 0 ? void 0 : ast.map((node) => {
            var _a;
            const Component = (_a = renderers[node.type]) !== null && _a !== void 0 ? _a : DefaultComponent;
            return _jsx(Component, { node: node }, node.key);
        }) }));
}
